import { toast } from "react-toastify";

const handleErrorJquery = ({ props, error }) => {
  if (error.status === 401) {
    props.set_login_action(false);
    localStorage.removeItem("token");
    toast.error("Unauthenticated");
  } else {
    toast.error("Failed to load data");
  }
};

function ErrorListToast({ messages }) {
  return (
    <div>
      <ul className="pt-3">
        {messages.map((message, index) => (
          <li key={index}>{message}</li>
        ))}
      </ul>
    </div>
  );
}

const handleErrors = (error, callback) => {
  const errorList = error.response.data.errors;
  const messages = errorList ? errorList.map((error) => {
    return error.message;
  }) : [error.response.data.message];
  toast.error(<ErrorListToast messages={messages} />);
};

export { handleErrorJquery, handleErrors };
